<app-page-heading [heading]="heading" [tabName]="'national-drug-formularies'"></app-page-heading>

<div *ngIf="isEdit && editNationalDrugFormulary.nationalDrugFormularyId == null" class="center-container">
  <mat-spinner></mat-spinner>
</div>

<div class="stepper-container">
  <mat-horizontal-stepper #stepper [linear]="true">

    <!----------------------------->
    <!--- STEP: Formulary Drugs:--->
    <!----------------------------->

    <mat-step [stepControl]="drugFormGroup" [completed]="drugFormGroup.valid">
      <ng-template matStepLabel>Formulary Drugs</ng-template>

      <div class="header-container">
        <p>Select national drugs using the filter and sort functions</p>
        <span class="header-spacer"></span>
        <div>
          <mat-slide-toggle [checked]="showSelectedDrugs"
                            (change)="toggleShowSelectedDrugs($event)">
            Show <b>{{selectionControl.selected?.length}}</b> Selected Drugs
          </mat-slide-toggle>
        </div>
      </div>

      <div *ngIf="!nationalDrugDataSource" class="center-container">
        <mat-spinner></mat-spinner>
      </div>
      <div *ngIf="nationalDrugDataSource" class="mat-elevation-z8 table-container">
        <table mat-table multiTemplateDataRows [dataSource]="nationalDrugDataSource" matSort
               (matSortChange)="sortData($event)">
          
          <ng-container [matColumnDef]="tableColumns.Select">
            <th style="width: 36px" mat-header-cell *matHeaderCellDef>
              <mat-checkbox (change)="$event ? masterToggle() : null"
                            [checked]="selectionControl.hasValue() && isAllSelected()"
                            [indeterminate]="selectionControl.hasValue() && !isAllSelected()">
              </mat-checkbox>
            </th>
            <td style="width: 36px" mat-cell *matCellDef="let row">
              <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? toggleSelect(row) : null"
                            [checked]="isSelected(row)">
              </mat-checkbox>
            </td>
          </ng-container>
          
          <ng-container [matColumnDef]="tableColumns.NationalDrugCode">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>
              <mat-form-field class="w-100">
              <textarea matInput class="table-column-filter" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                        cdkAutosizeMinRows="1" cdkAutosizeMaxRows="2"
                        (input)="onInputChangedFilterData($event, 'nationalDrugCode')"
                        (click)="$event.stopPropagation()" placeholder="Drug Code"></textarea>
              </mat-form-field>
            </th>
            <td *matCellDef="let row" mat-cell> {{row[tableColumns.NationalDrugCode]}}</td>
          </ng-container>
          
          <ng-container [matColumnDef]="tableColumns.BrandName">
            <th *matHeaderCellDef mat-header-cell mat-sort-header
                class="w-20">
              <mat-form-field class="w-100">
              <textarea matInput class="table-column-filter" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="1" cdkAutosizeMaxRows="2" (input)="onInputChangedFilterData($event, 'brandName')"
                (click)="$event.stopPropagation()" placeholder="Brand Name"></textarea>
              </mat-form-field>
            </th>
            <td *matCellDef="let row" mat-cell> {{row.brandName | slice:0:25}}</td>
          </ng-container>
          
          <ng-container [matColumnDef]="tableColumns.Ingredients">
            <th *matHeaderCellDef class="w-20" mat-header-cell>Ingredients</th>
            <td *matCellDef="let row" mat-cell>
              <ng-container *ngIf="row[tableColumns.Ingredients]?.length>1; else defaultSingleValue">
                <div gdTooltip>
                  <span >{{row['ingredientsFirstTooltip']}}</span>
                  <ng-template #tooltipTemplate>
                    <div class="tooltip">{{row['ingredientsFullToolTip']}}</div>
                  </ng-template>
                </div>
              </ng-container>
              <ng-template #defaultSingleValue>
                {{row['ingredientsFirstTooltip'] ?? 'N/A'}}
              </ng-template>
            </td>
          </ng-container>
          
          <ng-container [matColumnDef]="tableColumns.Manufacturer">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Manufacturer</th>
            <td *matCellDef="let row" mat-cell>{{row[tableColumns.Manufacturer]?.name ?? 'N/A'}} </td>
          </ng-container>
          
          <ng-container [matColumnDef]="tableColumns.StartDate">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Start Date</th>
            
            <ng-container *ngIf="!isEdit; else editModeFormularyStartDate">
              <td *matCellDef="let row" mat-cell>{{row[tableColumns.StartDate] | date: dateFormat}}</td>
            </ng-container>
            <ng-template #editModeFormularyStartDate>
              <td *matCellDef="let row" mat-cell>{{row['nationalDrugFormularyStartDate'] | date: dateFormat}}</td>
            </ng-template>
          </ng-container>
          
          <ng-container [matColumnDef]="tableColumns.EndDate">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>End Date</th>
            <ng-container *ngIf="!isEdit; else editModeFormularyEndDate">
              <td *matCellDef="let row" mat-cell>{{row[tableColumns.EndDate] | date: dateFormat}}</td>
            </ng-container>
            <ng-template #editModeFormularyEndDate>
              <td *matCellDef="let row" mat-cell>{{row['nationalDrugFormularyEndDate'] | date: dateFormat}}</td>
            </ng-template>
          </ng-container>
          
          <ng-container matColumnDef="expandedDetail">
            <td *matCellDef="let row" mat-cell [attr.colspan]="nationalDrugDisplayedColumns.length">
              <div class="row-detail-container"
                   [@detailExpand]="row == nationalDrugExpandedRow ? 'expanded' : 'collapsed'">
                <b>Drug Name: </b>{{row.drugName}}<br>
                <b>Master Drug Name: </b>{{row.masterDrug.name}}<br>
                <b>Regulator: </b>{{row.regulator.name}}<br>
                <b>Dosage form: </b>{{row.dosageForm.name}}<br>
                <b>Registration Owner: </b>{{row.registrationOwner}}<br>
                <b>Origin Reference: </b>{{row.referenceName}}<br>
                <b>Country: </b>{{row.country}}<br>
                <b>Currency: </b>{{row.currency.name}}<br>
                <b>Pack Price: </b>{{row.packPrice}}<br>
                <b>Each Price: </b>{{row.eachPrice}}<br>
                <b>Status: </b>{{row.status.name}}<br>
                <b>Approval Reference: </b>{{row.approvalReference}}<br>
                <b>Approval Date: </b>{{row.approvalDate | date: dateFormat}}<br>
                <b>Drug Valid From: </b>{{row.startDate | date: dateFormat}}<br>
                <b>Drug Valid to: </b>{{row.endDate | date: dateFormat}}<br>
                <b>Created By: </b>{{row.createdBy}}<br>
                <b>Created Date: </b>{{row.created | date: dateTimeFormat}}<br>
                <b>Updated By: </b>{{row.updatedBy}}<br>
                <b>Updated Date: </b>{{row.updated | date: dateTimeFormat}}<br>
              </div>
            </td>
          </ng-container>
          
          <tr mat-header-row *matHeaderRowDef="nationalDrugDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let tableRow; columns: nationalDrugDisplayedColumns;" class="row"
              [class.expanded-row]="nationalDrugExpandedRow == tableRow"
              (click)="nationalDrugExpandedRow = nationalDrugExpandedRow === tableRow ? null : tableRow">
          </tr>
          <tr mat-row *matRowDef="let tableRow; columns: ['expandedDetail'];" class="detail-row"></tr>
        
        </table>
        
        <mat-paginator #nationalDrugPaginator
                       [length]="nationalDrugTableControl.length"
                       [pageSize]="nationalDrugTableControl.pageSize"
                       [pageIndex]="0"
                       [pageSizeOptions]="nationalDrugTableControl.pageSizeOptions"
                       (page)="pageChanged($event)">
        </mat-paginator>
      
      </div>
      <div class="button-container">
        <button mat-raised-button (click)="drugsClear()" color="warn">Clear</button>
        <button mat-raised-button (click)="drugsNext()" color="primary">Next</button>
      </div>
    </mat-step>

    <!----------------------------->
    <!------- STEP: Details:------->
    <!----------------------------->

    <mat-step [stepControl]="detailFormGroup" [completed]="detailFormGroup.valid">
      <ng-template matStepLabel>Details</ng-template>
      <form [formGroup]="detailFormGroup">
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Formulary Name</mat-label>
              <input (input)="onChangeInputFormularyName($event)" [formControl]="nameFormControl" matInput required
                     type="text">
            </mat-form-field>
            <mat-icon class="info-icon" #nameTooltip="matTooltip"
                      [matTooltip]="getInfoTooltip('Formulary Name')">help_outline
            </mat-icon>
          </mat-grid-tile>
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Formulary Class</mat-label>
              <mat-select name="class" required [formControl]="classFormControl">
                <mat-option *ngFor="let class of classes" [value]="class.name">
                  {{class.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon class="info-icon" #classTooltip="matTooltip"
                      [matTooltip]="getInfoTooltip('Formulary Class')">help_outline
            </mat-icon>
          </mat-grid-tile>
          <mat-grid-tile>
            <greydom-date-picker
              label="Start Date"
              [required]="true"
              [formControl]="startDateFormControl"
              [tooltip]="getInfoTooltip('Start Date')"
              [maxDate]="endDateFormControl.value">
            </greydom-date-picker>
          </mat-grid-tile>
          <mat-grid-tile>
            <greydom-date-picker
              label="End Date"
              [required]="true"
              [formControl]="endDateFormControl"
              [tooltip]="getInfoTooltip('End Date')"
              [minDate]="startDateFormControl.value">
            </greydom-date-picker>
          </mat-grid-tile>
        </mat-grid-list>
        <div class="button-container">
          <button mat-raised-button matStepperPrevious color="primary">Back</button>
          <button mat-raised-button color="warn">Clear</button>
          <button mat-raised-button matStepperNext color="primary" [disabled]="!detailFormGroup.valid">Next</button>
        </div>
      </form>
    </mat-step>

    <!----------------------------->
    <!------- STEP: Finish:-------->
    <!----------------------------->

    <mat-step>
      <ng-template matStepLabel>Finish</ng-template>
      <mat-grid-list cols="2" rowHeight="75px">
        <mat-grid-tile>
          <div class="display-field">
            <p class="label">Formulary Name</p>
            <p class="content">{{nameFormControl.value}}</p>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="display-field">
            <p class="label">Formulary Class</p>
            <p class="content">{{classFormControl.value}}</p>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="display-field">
            <p class="label">Start Date</p>
            <p class="content">{{startDateFormControl.value | date: dateFormat}}</p>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="display-field">
            <p class="label">End Date</p>
            <p class="content">{{endDateFormControl.value | date: dateFormat}}</p>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
        
        </mat-grid-tile>
      </mat-grid-list>
      <div class="button-container">
        <button mat-raised-button matStepperPrevious color="primary">Back</button>
        <button mat-raised-button matStepperPrevious color="warn" (click)="stepper.reset()">Clear</button>
        <button mat-raised-button color="primary" (click)="onClickFinish()">Finish</button>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</div>